import React, { useEffect } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './AdminLayout.css';

const AdminLayout = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div className="admin-container">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h2>{t('blog.adminTitle')}</h2>
        </div>
        <ul className="admin-nav">
          <li>
            <NavLink to="/admin/posts"><i className="fas fa-list-alt"></i> {t('blog.allPosts')}</NavLink>
          </li>
          <li>
            <NavLink to="/admin/posts/new"><i className="fas fa-plus-circle"></i> {t('blog.newPost')}</NavLink>
          </li>
          <li>
            <NavLink to="/admin/stats"><i className="fas fa-chart-bar"></i> {t('blog.statsTitle')}</NavLink>
          </li>
        </ul>
        <div className="admin-sidebar-footer">
          <button onClick={handleLogout} className="admin-logout-btn">
            <i className="fas fa-sign-out-alt"></i> Çıkış Yap
          </button>
        </div>
      </aside>
      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;